export default __webpack_public_path__ + "static/media/CSCLOGO.c8e46865.png";